// extracted by mini-css-extract-plugin
export var darkMode = "_m-0";